import { render, staticRenderFns } from "./HeaderBottom.vue?vue&type=template&id=ed8352f0"
import script from "./HeaderBottom.vue?vue&type=script&lang=ts"
export * from "./HeaderBottom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports